/**
 * Google select address
 */
export default function () {
    const googleSelectAddress = document.querySelectorAll(".google-select-address");
    if (googleSelectAddress?.length) {
        function loadGoogleMapsScript(select) {
            const existingScript = document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]');
            const apiKey = select?.getAttribute('data-api-key');
            const language = select?.getAttribute('data-language') ?? 'en';


            if (existingScript || !select || !apiKey) return

            const script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&callback=initAutocomplete&language=${language}`;
            script.async = true;
            script.defer = true;

            document.head.appendChild(script);
        }

        loadGoogleMapsScript(googleSelectAddress[0]);

        if (typeof window.initAutocomplete === 'undefined') {
            window.initAutocomplete = function () {
                googleSelectAddress.forEach(select => {
                    const lat = select.querySelector("#lat").value;
                    const lng = select.querySelector("#lng").value;
                    if (lat && lng && !select.querySelector("#address").value) {
                        const geocoder = new google.maps.Geocoder();
                        const latlng = {lat: parseFloat(lat), lng: parseFloat(lng)};

                        geocoder.geocode({location: latlng}, function (results, status) {
                            if (status === "OK" && results[0]) {
                                select.querySelector("#address").value = results[0].formatted_address;
                                select.querySelector('#address_google_object').value = JSON.stringify(results[0].address_components);
                            }
                        });
                    }

                    const input = select.querySelector('input')
                    const autocomplete = new google.maps.places.Autocomplete(input);

                    autocomplete.addListener("place_changed", function () {
                        const place = autocomplete.getPlace();
                        if (!place.geometry) return;

                        // Salva le coordinate
                        select.querySelector("#lat").value = place.geometry.location.lat();
                        select.querySelector("#lng").value = place.geometry.location.lng();

                        let street = '';
                        let streetNumber = '';
                        let zip = '';
                        let city = '';
                        let province = '';
                        let country = '';
                        let countryCode = '';
                        var data = {"value": place.formatted_address, "latlng": place.geometry.location};
                        // Itera attraverso i componenti dell'indirizzo
                        for (const component of place.address_components) {
                            const types = component.types;
                            data[types] = component.long_name;
                            if (types.includes('route')) {
                                street = component.long_name;
                            }
                            if (types.includes('street_number')) {
                                streetNumber = component.long_name;
                            }
                            if (types.includes('postal_code')) {
                                zip = component.long_name;
                            }
                            if (types.includes('locality')) {
                                city = component.long_name;
                            }
                            if (types.includes('administrative_area_level_2')) {
                                province = component.short_name;
                            }
                            if (types.includes('country')) {
                                country = component.long_name;
                                countryCode = component.short_name;
                            }
                        }

                        // Componi l'indirizzo completo della via
                        select.querySelector("#address_google").value = street + (streetNumber ? ', ' + streetNumber : '');
                        select.querySelector("#address_google_object").value = JSON.stringify(data);
                        select.querySelector("#zip").value = zip;
                        select.querySelector("#city").value = city;
                        select.querySelector("#province").value = province;
                        select.querySelector("#country").value = country;
                        select.querySelector("#countryCode").value = countryCode;
                    });
                })
            }
        }
    }
}
